module.exports = __webpack_public_path__ + "img/shipo-icon-redo.fd47549b.svg";